"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('loading');
const Loading = (props) => {
    const { style, type, color = '#999', gapColor = '#FDFFFD', radius = '42px' } = props;
    if (type === 'gap') {
        return (React.createElement(one_1.View, { className: `${prefixCls}-gap`, style: {
                height: radius,
                width: radius,
                border: `2px solid ${color}`,
            } },
            React.createElement(one_1.View, { className: `${prefixCls}-gap-fill`, style: {
                    backgroundColor: gapColor,
                } })));
    }
    if (type === 'wave') {
        return (React.createElement(one_1.View, { className: `${prefixCls}-wave` },
            React.createElement(one_1.View, { style: { backgroundColor: color } }),
            React.createElement(one_1.View, { style: { backgroundColor: color } }),
            React.createElement(one_1.View, { style: { backgroundColor: color } }),
            React.createElement(one_1.View, { style: { backgroundColor: color } }),
            React.createElement(one_1.View, { style: { backgroundColor: color } })));
    }
    if (type === 'anna') {
        return (React.createElement(one_1.View, { className: `${prefixCls}-anna` },
            React.createElement(one_1.View, { style: { backgroundColor: color } }),
            React.createElement(one_1.View, { style: { backgroundColor: color } }),
            React.createElement(one_1.View, { style: { backgroundColor: color } })));
    }
    return (React.createElement(one_1.View, { className: prefixCls, style: Object.assign(Object.assign({}, style), { height: radius, width: radius, borderColor: `${color} ${color} transparent` }) }));
};
exports.default = Loading;
